export default __webpack_public_path__ + "static/media/xiconblack.2ba2055a.svg";